import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom'
// import Modal from "react-modal";
import "./mainTable.scss";
import Checkbox3 from "../checkbox/Checkbox3";
import { SHOW_MAIN_ERROR_MODAL } from '../../../redux/errorMessageSlice';
import Checkbox1 from "../checkbox/Checkbox1";
import { PrintData } from '../../../comonComponent/print-2d/PrintLottery';
import PlaceBat2d from '../place-bat/PlaceBat2d';
import { setAdvanceTimeSlotCount,selectAdvaceTimeSlotCount } from '../../../redux/seriesSlice';
import { SET_MAIN_LOADER } from "../../../redux/loaderSlice";
import {
  SelectSeriesPartAll,
  RESET_SLICE_STATE,
  SelectSeriesPart,
  SET_SERIES_PART_CHECKED,
  SET_SERIES_TYPE,
  SelectSeriesType,
  SET_ACTIVE_SERIES_INDEX,
  SelectActiveSeriesPartIndex, SET_LAST_INPUT_CHANGE_RECORD,
  SelectActiveSeriesIndex,
  SET_ACTIVE_SERIES_PART_INDEX,
  SelecrSeriesStore,
  SET_PREVIEWS_ACTIVE_SERIES_DETAIL,
  SelectSeriesTypeDisableFlag,
  SET_IS_MULTI,
  SelectIsMulti,
  SET_SERIES_STORE,
  SelectResultArray
} from "../../../redux/2d-slice/seriesSlice2d";
import { SET_ADVANCE_DRAW_SELECT_TIME, SET_CLAIM_TICKET_ID, SelectAdvanceDrawSelectTime, SelectPrintData, SET_LAST_SALE_AMOUNT, SET_LAST_TICKET_ID, SET_PRINT_DATA } from '../../../redux/2d-slice/gameInfo2dSlice';
import { useDispatch, useSelector } from "react-redux";
import SideTableSeriesCheckbox from "./component/SideTableSeriesCheckbox";
import HorizontalInputContainer from "./component/HorizontalInputContainer";
import VerticalInputContainer from "./component/VerticalInputContainer";
import RightResultContainer from "./component/RightResultContainer";
import { SocketState } from "../../../context/SocketProvider";
import { AuthState } from "../../../context/AuthProvider";

function MainTable() {
  const dispatch = useDispatch();
  const { socket } = SocketState()
  const { userDetail } = AuthState()
  const seriesStore = useSelector(SelecrSeriesStore);

  const advanceTimeSlotCount = useSelector(selectAdvaceTimeSlotCount);
  const selectSeriesPart = useSelector(SelectSeriesPart);
  const activeSeriesIndex = useSelector(SelectActiveSeriesIndex);
  const activeSeriesPartIndex = useSelector(SelectActiveSeriesPartIndex);
  const isMulti = useSelector(SelectIsMulti);


  const resultArray = useSelector(SelectResultArray);
  const AdvanceDrawSelectTime = useSelector(SelectAdvanceDrawSelectTime);

  const navigate = useNavigate()

  const [showWhatsappPopup, setShowWhatsappPopup] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");

  let seriesType = useSelector(SelectSeriesType)
  let seriesTypeDisableFlag = useSelector(SelectSeriesTypeDisableFlag)

  // input ref
  const inputRefs = useRef([]);
  // HorizontalInput ref
  const horizontalInputRefs = useRef([]);
  // verticalInput ref
  const verticalInputaRefs = useRef([]);

  // helper: find the best source index to copy active parts/values from
  const findSourceWithActiveParts = () => {
    // prefer the currently active series if it has active parts
    if (seriesStore[activeSeriesIndex]?.AllSeriesPartName?.some((p) => p.active)) {
      return activeSeriesIndex;
    }
    // otherwise find first series that has active parts
    const idx = seriesStore.findIndex((s) => s?.AllSeriesPartName?.some((p) => p.active));
    if (idx !== -1) return idx;
    // fallback to activeSeriesIndex or 0
    return Number.isInteger(activeSeriesIndex) ? activeSeriesIndex : 0;
  };

  // Create the downHandler with useCallback to prevent unnecessary recreations
  const downHandler = useCallback((e) => {
    let { key, code } = e

    if (code === "Space") {
      e.preventDefault(); // page scroll stop
    }
    if (key === 'F5') {
      e.preventDefault()
      dispatch(RESET_SLICE_STATE());
      dispatch(SET_ADVANCE_DRAW_SELECT_TIME([]))
    }
    if (key === 'F1') {
      navigate('resultModal2d')
    }
    if (key === 'F3') {
      navigate('reprint')
    }
    if (key === 'F2') {
      navigate('report')
    }
    if (key === 'F4') {
      navigate('cancel-ticket')
    }
    if (key === 'F9') {
      navigate('advance')
    }
    if (code === "Space") {
      navigate('claim-ticket');
    }
  }, [dispatch, navigate]);

  // Add the keydown event listener for F5, F6, etc.
  useEffect(() => {
    window.addEventListener("keydown", downHandler);

    return () => {
      window.removeEventListener("keydown", downHandler);
    }
  }, [downHandler]);

  useEffect(() => {
    document.addEventListener('keydown', event => {
      if (event.keyCode === 74 || event.keyCode === 2) {
        event.preventDefault();
        return false;
      }
    });
    return () => {
      document.removeEventListener('keydown', null)
    }
  }, [])

  let handleScan = (data) => {
    let ticket_id = data.slice(1)
    dispatch(SET_CLAIM_TICKET_ID(ticket_id))
    navigate('claim-ticket')
  }

  let handleError = (err) => {
    // console.log('err: ', err);
    // dispatch(SHOW_MAIN_ERROR_MODAL('Somthing went wrong'))
    // toast.error('Somthing wrong')
  }

  let resetCode = () => {
    seriesStore.forEach((series) => {
      series.AllSeriesPartName.forEach((partName) => {
        partName.active = false
      })

      series.seriesAllfield.forEach((fields) => {
        fields.forEach(field => {

          field.resetValue()
        })
      })
    })

    dispatch(SET_SERIES_STORE(seriesStore))
    dispatch(SET_ACTIVE_SERIES_INDEX(0))
    dispatch(SET_ACTIVE_SERIES_PART_INDEX(0))
    dispatch(SET_LAST_INPUT_CHANGE_RECORD())
    dispatch(SET_PREVIEWS_ACTIVE_SERIES_DETAIL({ lastSeriesIndex: null, lastSeriesPartIndex: null, isActiveSeriesName: false }))
    dispatch(SET_SERIES_PART_CHECKED(new Array(3).fill(false)))
    dispatch(SET_ADVANCE_DRAW_SELECT_TIME([]))
  }

  const submitBat = useCallback(() => {
    // console.log("✅ submitBat triggered");

    dispatch(SET_MAIN_LOADER(true));

    let card_details = {};
    let totalAmount = 0; // ✅ TOTAL CALCULATION
    resultArray.forEach((resArray, resIndex) => {
      resArray.forEach((_, resultIndex) => {
        const seriesField = seriesStore[resIndex]?.seriesAllfield?.[resultIndex] || [];
        seriesField.forEach((inputField) => {
          const val = inputField?.getFinalValue?.() ?? 0;
          if (val > 0) {
            card_details[inputField.printNumber] = val * 2;
            totalAmount += val * 2; // ✅ ADD TO TOTAL
          }
        });
      });
    });

    
    // ❌ CONDITION: total 10 se upar hona chahiye
    if (totalAmount < 10) {
        dispatch(
          SHOW_MAIN_ERROR_MODAL(
            "❌ Minimum Bet Amount Total 10 se Zyada Hona Chahiye"
          )
        );
        dispatch(SET_MAIN_LOADER(false));
    return;
    }

    const mobile_number = localStorage.getItem("mobile_number") ?? null;
    // console.log("📞 Sending with mobile number:", mobile_number);

    socket.emit("req", {
      en: "MINI_LOTTERY_PLACE_BET",
      data: {
        advance_bet: AdvanceDrawSelectTime.length > 0,
        advance_bet_times: AdvanceDrawSelectTime,
        card_details,
        mobile_number,
      },
    });

    localStorage.removeItem("mobile_number");
  }, [dispatch, resultArray, seriesStore, socket, AdvanceDrawSelectTime]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "F6") {
        event.preventDefault();
        submitBat();
      }
    };

    const handleWhatsappPlaceBet = () => {
      // console.log("📲 whatsappPlaceBet event received");
      submitBat();
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("whatsappPlaceBet", handleWhatsappPlaceBet);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("whatsappPlaceBet", handleWhatsappPlaceBet);
    };
  }, [submitBat]);

  useEffect(() => {
    if (!socket) return;

    const listener = (socketData) => {
      if (socketData.en === "MINI_LOTTERY_PLACE_BET") {

        dispatch(SET_MAIN_LOADER(false));

        if (socketData.err) {
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg));
          return;
        }

        dispatch(SET_LAST_SALE_AMOUNT(socketData.data.total_bet_amount));
        dispatch(SET_LAST_TICKET_ID(socketData.data.ticket_id));

        // userDetail ka snapshot yahin read karo
        const currentUserBet = userDetail?.user_bet;

        if (!currentUserBet) {
          PrintData(socketData.data, dispatch);
        }

        dispatch(RESET_SLICE_STATE());
        dispatch(SET_ADVANCE_DRAW_SELECT_TIME([]));
        dispatch(setAdvanceTimeSlotCount(0));
      }
    };

    socket.on("res", listener);

    return () => {
      socket.off("res", listener);
    };
  }, [socket]);   // ❗ userDetail hata diya


  return (
    <>
      <tr colSpan="2" className="flex">
        <table width="20%" height="100%" border="0" bgcolor="#d9d9d9" cellSpacing="0" cellPadding="0" style={{ borderCollapse: 'collapse', fontSize: '14px' }}>
          <tbody>
            <tr>
              <td style={{ fontSize: "22px", textAlign: "center", fontWeight: "900", textStrokeWidth: "1px", textStrokeColor: 'black', color: "#7300ffff" }}>LAXMI COUPON</td>
            </tr>
            <tr>
              <td>
                <table style={{ width: "100%" }} border="0">
                  <tbody>
                    <tr>
                      <div className="checkbox_container flex items-center float-left">
                        {[
                          { type: 'All', color: '#FF9900' },
                          { type: 'Odd', color: '#FF00FF' },
                          { type: 'Even', color: '#00FFFF' },
                        ].map((item, index) => {
                          return (
                            <th
                              key={index}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: item.color,
                                padding: '5px',
                              }}
                            >
                              <Checkbox1
                                checked={seriesType === item.type}
                                style={{ width: '20px', height: '20px' }}
                                id={item.type}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    dispatch(SET_SERIES_TYPE(item.type));
                                  } else {
                                    dispatch(SET_SERIES_TYPE('All'));
                                  }
                                }}
                                disabled={seriesTypeDisableFlag}
                              />
                              <label className="checkbox_label ml-1">{item.type}</label>
                            </th>
                          );
                        })}
                      </div>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table width="100%">
                  <tbody >
                    <SideTableSeriesCheckbox />
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <table width="90%" height="100%" style={{ fontSize: '14px' }}>
          <tbody>
            <tr className="justify-center">
              <div>
                <td style={{
                  alignItems: 'center',
                  backgroundColor: '#FF00FF',
                  padding: '5px',
                }}>

                  <div className="flex">
                    <Checkbox3
                      checked={isMulti}
                      style={{ width: '20px', height: '20px' }}
                      onChange={(e) => {
                        dispatch(SET_IS_MULTI(e.target.checked));
                        // if (e.target.checked) {
                        //   const updatedChecked = [...selectSeriesPart];
                        //   updatedChecked[0] = true; // Select 10's checkbox
                        //   dispatch(SET_SERIES_PART_CHECKED(updatedChecked));
                        // }
                      }}
                    />
                    <label className="checkbox_label ml-1">MULTI</label></div>
                </td>
                <td style={{
                  alignItems: 'center',
                  backgroundColor: '#00FFFF',
                  padding: '5px',
                }}>
                  <div className="flex">
                    <Checkbox3
                      checked={!selectSeriesPart.includes(false)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          dispatch(SET_SERIES_PART_CHECKED(new Array(3).fill(true)));

                          // set all parts active (normal mode)
                          const updatedStore = seriesStore.map((series) => ({
                            ...series,
                            AllSeriesPartName: series.AllSeriesPartName.map((partname) => ({
                              ...partname,
                              active: true,
                            })),
                          }));

                          if (!isMulti) dispatch(SET_SERIES_STORE(updatedStore));
                        } else {
                          dispatch(SET_SERIES_PART_CHECKED(new Array(3).fill(false)));

                          const updatedStore = seriesStore.map((series) => ({
                            ...series,
                            AllSeriesPartName: series.AllSeriesPartName.map((partname) => ({
                              ...partname,
                              active: false,
                            })),
                          }));

                          dispatch(SET_SERIES_STORE(updatedStore));
                        }
                      }}
                    />
                    <label className="checkbox_label ml-1">ALL</label>
                  </div>
                </td>
                {[10, 30, 50].map((series, index) => {

                  return (
                    <td
                      key={index} style={{
                        alignItems: 'center',
                        backgroundColor: index === activeSeriesIndex ? "#000000ff" : "" || (index % 2 === 0 ? "#96B2D9" : "#F8F7A3"),
                        cursor: "pointer",
                        padding: '5px',
                      }}
                      className={`series_tab_btn ${activeSeriesIndex === index ? "series_tab_btn_active" : ""}`}
                    // onClick={(e) => {
                    //   // if user clicked the checkbox area we already stopPropagation there,
                    //   // otherwise clicking the tab selects the tab

                    // }}
                    >
                      {/* stop propagation so the parent's onClick doesn't trigger when clicking the checkbox */}
                      <div className="series-checkbox flex" onClick={(e) => {
                        e.stopPropagation();
                        dispatch(SET_ACTIVE_SERIES_INDEX(index));
                        dispatch(SET_ACTIVE_SERIES_PART_INDEX(activeSeriesPartIndex));
                      }}>
                        <Checkbox3
                          checked={selectSeriesPart[index]}
                          onChange={(e) => {
                            const checked = e.target.checked;

                            // determine source: prefer a series that actually has active JP parts
                            const sourceIndex = findSourceWithActiveParts();
                            const sourceParts = seriesStore[sourceIndex]?.AllSeriesPartName ?? [];
                            const sourceFields = seriesStore[sourceIndex]?.seriesAllfield ?? [];

                            // Build updated AllSeriesPartName flags immutably
                            const updatedSeriesStore = seriesStore.map((s, sIdx) => {
                              if (sIdx !== index) return s;

                              let newParts;
                              if (checked) {
                                if (isMulti) {
                                  // reset before applying
                                  s.seriesAllfield.forEach((fieldArr) =>
                                    fieldArr.forEach((field) => field.resetValue?.())
                                  );

                                  newParts = s.AllSeriesPartName.map((p, i) => ({
                                    ...p,
                                    active: !!sourceParts[i]?.active,
                                  }));
                                } else {
                                  // reset before applying
                                  s.seriesAllfield.forEach((fieldArr) =>
                                    fieldArr.forEach((field) => field.resetValue?.())
                                  );

                                  newParts = s.AllSeriesPartName.map((p) => ({ ...p, active: true }));
                                }
                              } else {
                                // ✅ on uncheck, clear values immediately
                                newParts = s.AllSeriesPartName.map((p) => ({ ...p, active: false }));

                                s.seriesAllfield.forEach((fieldArr) =>
                                  fieldArr.forEach((field) => {
                                    field.resetValue?.();
                                  })
                                );
                              }

                              return {
                                ...s,
                                AllSeriesPartName: newParts,
                              };
                            });

                            // apply value copying to the *in-memory* fields (so inputs update)
                            try {
                              if (checked) {
                                // if copying from sourceParts that are active, set target values to match source
                                for (let partIdx = 0; partIdx < (seriesStore[index]?.AllSeriesPartName?.length ?? 0); partIdx++) {
                                  if (isMulti) {
                                    if (!sourceParts[partIdx]?.active) continue; // only copy active parts
                                  }
                                  const srcFields = sourceFields[partIdx] ?? [];
                                  const tgtFields = seriesStore[index]?.seriesAllfield?.[partIdx] ?? [];
                                  for (let f = 0; f < tgtFields.length; f++) {
                                    const val = Number(srcFields[f]?.getFinalValue?.() ?? 0);
                                    if (tgtFields[f]?.setValue) tgtFields[f].setValue(val);
                                  }
                                }
                              } else {
                                // unchecking → clear all target part values to 0
                                for (let partIdx = 0; partIdx < (seriesStore[index]?.AllSeriesPartName?.length ?? 0); partIdx++) {
                                  const tgtFields = seriesStore[index]?.seriesAllfield?.[partIdx] ?? [];
                                  for (let f = 0; f < tgtFields.length; f++) {
                                    if (tgtFields[f]?.setValue) tgtFields[f].setValue(0);
                                  }
                                }
                              }
                            } catch (err) {
                              // defensive: avoid runtime crash if some fields are missing
                              // console.warn("value copy issue:", err);
                            }

                            // update Redux store
                            dispatch(SET_SERIES_STORE(updatedSeriesStore));

                            // update preview (use updated store to decide preview)
                            dispatch(
                              SET_PREVIEWS_ACTIVE_SERIES_DETAIL({
                                lastSeriesIndex: activeSeriesIndex,
                                lastSeriesPartIndex: activeSeriesPartIndex,
                                isActiveSeriesName:
                                  updatedSeriesStore[activeSeriesIndex]?.AllSeriesPartName?.[activeSeriesPartIndex]?.active ?? false,
                              })
                            );

                            // update series-level checked array (immutable)
                            const changeSelectSeriesPart = [...selectSeriesPart];
                            changeSelectSeriesPart[index] = checked;
                            dispatch(SET_SERIES_PART_CHECKED(changeSelectSeriesPart));

                            // UX: if user checked this series, make it active (tab)
                            dispatch(SET_ACTIVE_SERIES_INDEX(index));
                            if (checked) {
                              dispatch(SET_ACTIVE_SERIES_PART_INDEX(activeSeriesPartIndex));
                            }
                          }}
                        />
                        <label style={{ color: index === activeSeriesIndex ? "#ffffff" : "#000000" }}>{series}</label>
                      </div>
                    </td>
                  );
                })}
                <td style={{
                  alignItems: 'center',
                  width: '5%',
                }}> </td>
                <td style={{
                  alignItems: 'center',
                  backgroundColor: '#00c3ffff',
                }}>
                  <div className="checkbox_label font-bold text-white px-2" onClick={(e) => {
                    e?.preventDefault()
                    socket.emit('req', {
                      en: "LOTTARY_CLOSE_GAME",
                      data: {}
                    });
                    // navigate("/3d");
                    localStorage.setItem("gameRoute", "3d")
                  }} > 3D</div>
                  {/* <label className="checkbox_label ml-1">MULTI</label> */}
                </td>

                {/* <td style={{
                  alignItems: 'center',
                  width: '5%',
                }}> </td>
                <td style={{
                  alignItems: 'center',
                  backgroundColor: '#FF00FF',
                }}>
                  <div className="checkbox_label font-bold text-white px-2" onClick={(e) => {
                    e?.preventDefault()
                    socket.emit('req', {
                      en: "LOTTARY_CLOSE_GAME",
                      data: {}
                    });
                    // navigate("/3d");
                    localStorage.setItem("gameRoute", "Titli")
                  }} > TITLI</div>
                </td> */}


                <td style={{
                  alignItems: 'center',
                  width: '5%',
                }}> </td>
                <td style={{
                  alignItems: 'center',
                  backgroundColor: '#FF9900',
                }}>
                  <div className="checkbox_label font-bold text-white px-2" onClick={(e) => {
                    e?.preventDefault()
                    socket.emit('req', {
                      en: "LOTTARY_CLOSE_GAME",
                      data: {}
                    });
                    localStorage.setItem("gameRoute", "1d")
                  }} > 2D</div>
                </td>
                {/* <td style={{
                  alignItems: 'center',
                  backgroundColor: '#FF00FF',
                  padding: '5px',
                }}>
                  <img src="images/3DLogo.png" style={{ height: '20px'}} onClick="goto3dlogo();" />
                </td> */}
              </div>
            </tr>
            <tr>
              <td>
                <table border="1" cellSpacing="0" cellPadding="0" style={{ borderCollapse: 'collapse' }}>
                  <tbody>
                    <tr>
                      <HorizontalInputContainer horizontalInputRefs={horizontalInputRefs} verticalInputaRefs={verticalInputaRefs} inputRefs={inputRefs} />
                    </tr>
                    <VerticalInputContainer verticalInputaRefs={verticalInputaRefs} inputRefs={inputRefs} horizontalInputRefs={horizontalInputRefs} />
                  </tbody>
                </table>
              </td>
            </tr>

            <tr colSpan="2" className="flex">
              <th colSpan="2" align="left" valign="bottom" scope="col">
                <table width="80%" border="0">
                  <tbody>
                    <tr>

                      {userDetail?.whatsapp && (
                        <th
                          width="5%"
                          bordercolor="#FFFFFF"
                          scope="col"
                          style={{
                            width: "10%", height: "40px", background: "#00FF00",
                            border: " #000 solid 1px"
                          }}
                          onClick={() => setShowWhatsappPopup(true)}
                        >
                          Whatsapp
                        </th>)}
                      <th width="1%" scope="col">&nbsp;</th>
                      {userDetail?.print && (
                        <th width="10%" bordercolor="#FFFFFF" bgcolor="#FFFF00" scope="col" style={{
                          textAlign: 'center',
                          borderWidth: '0px',
                          borderRadius: '5px',
                          padding: '5px 10px',
                          cursor: 'pointer',
                          backgroundColor: 'yellow',
                          color: 'black',
                        }} id="PrintDv1">
                          <div align="center" id="PrintDv11">
                            <PlaceBat2d key={'footer'} /></div>
                        </th>)}
                      <th width="1%" scope="col">&nbsp;</th>
                      <th
                        width="20%"
                        scope="col"
                        style={{
                          textAlign: 'center',
                          borderRadius: '5px',
                          padding: '5px 10px',
                        width:"20%",
                          cursor: 'pointer',
                          backgroundColor: '#01b0f1',
                          color: 'black',
                          position: 'relative' // ⭐ important
                        }}
                        id="PrintDv3"
                      >
                        <div
                          onClick={() => navigate('advance')}
                          style={{ position: 'relative', display: 'flex' }}
                        >
                          Advance {' '}

                          {/* 🔴 Green Count Badge */}
                          {advanceTimeSlotCount > 0 && (
                            <span
                              style={{
                                backgroundColor: '#cc2e2eff',
                                color: '#fff',
                                borderRadius: '50%',
                                padding: '2px 5px ',
                                fontWeight: 'bold'
                              }}
                            >
                              {advanceTimeSlotCount}
                            </span>
                          )}
                        </div>
                      </th>
                      <th width="1%" scope="col">&nbsp;</th>
                      {userDetail?.auto_claim == false && (
                        <th width="5%" bordercolor="#FFFFFF" bgcolor="#77933c" scope="col" style={{
                          textAlign: 'center',
                          borderWidth: '0px',
                          borderRadius: '5px',
                          padding: '5px 10px',
                          cursor: 'pointer',
                          backgroundColor: '#77933c',
                          color: 'black',
                        }} onClick={() => navigate('claim-ticket')}>Claim</th>)}
                      <th width="1%" scope="col">&nbsp;</th>
                      {userDetail?.user_bet && (
                        <th
                          width="5%"
                          bordercolor="#FFFFFF"
                          bgcolor="#0004ffff"
                          scope="col"
                          style={{
                            textAlign: 'center',
                            borderWidth: '0px',
                            borderRadius: '5px',
                            padding: '5px 10px',
                            cursor: 'pointer',
                            color: 'white',
                          }}
                          onClick={() => submitBat()}
                        >
                          Bet
                        </th>)}
                    </tr>
                  </tbody>
                </table>
              </th>
            </tr>
          </tbody>
        </table>
        <table width="15%" height="100%" border="0" style={{ fontSize: '14px' }}>
          <tbody>
            <tr>
              <td>
                <RightResultContainer />
              </td>
            </tr>
          </tbody>
        </table>
      </tr>
      {showWhatsappPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px 30px",
              borderRadius: "10px",
              boxShadow: "0 0 15px rgba(0,0,0,0.3)",
              width: "300px",
              textAlign: "center",
            }}
          >
            <h3 style={{ marginBottom: "15px" }}>Enter Mobile Number</h3>
            <input
              type="tel"
              placeholder="Enter mobile number"
              min='10'
              max='10'
              value={mobileNumber}
              onChange={(e) => {
                const value = e.target.value
                if (value.length > 10) {
                  alert("Mobile number must be 10 digits only")
                  return
                }
                if (/^\d*$/.test(value)) {
                  setMobileNumber(value)
                }
              }}
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                marginBottom: "15px",
              }}
            />
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <button
                style={{
                  backgroundColor: "#28a745",
                  color: "#fff",
                  border: "none",
                  padding: "8px 12px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (mobileNumber.trim().length < 10) {
                    alert("Please enter a valid mobile number");
                    return;
                  }
                  localStorage.setItem("mobile_number", mobileNumber);

                  // Trigger event
                  window.dispatchEvent(new Event("whatsappPlaceBet"));

                  // close after slight delay
                  setTimeout(() => {
                    setShowWhatsappPopup(false);
                    setMobileNumber("");
                  }, 100);
                }}

              >
                Submit
              </button>
              <button
                style={{
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  border: "none",
                  padding: "8px 12px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setShowWhatsappPopup(false);
                  setMobileNumber("");
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default MainTable;
